import script from "./PlantillasVista.vue?vue&type=script&setup=true&lang=js"
export * from "./PlantillasVista.vue?vue&type=script&setup=true&lang=js"

import "./PlantillasVista.vue?vue&type=style&index=0&id=cd3fde5a&scoped=true&lang=scss"

import exportComponent from "C:\\AgentesAzure\\SVRAPQAHIR01\\vsts-agent-win-x64-4.261.0\\_work\\18\\s\\hircasa-srp-webapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd3fde5a"]])

export default __exports__